import { Route, Routes } from "react-router-dom"
import { Main } from "../pages/main"


const LogbookRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
    </Routes>
  )
}

export default LogbookRoutes
